<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">高质量动态代理</div>
          <div class="content">自建高质量代理服务器，稳定在线，随机动态IP专为数据分析类业务定制。</div>
        </div>
        <div class="right-banner">
          <img
            class=""
            src="./../assets/dynamic/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <div class="dynamic">
      <div class="left">
        <div class="title">什么是动态代理</div>
        <div class="text top">
          以常用的代理为例：220.101.1.51:9064，使用此代理访问百度，识别出的IP是220.101.1.51。百度识别出的代理跟使用的代理一致，想更换IP就需要不停更换代理。
        </div>
        <div class="text">
          动态代理相比于传统的代理举例：220.102.2.108:9064，此时使用此动态代理去访问百度，识别到的IP并不是220.102.2.108，而是随机IP，且每次都会变化。只需设置一次代理，就可以得到随机变化的IP，免去频繁更换代理的繁琐。
        </div>
      </div>
      <div class="right">
        <img
          class=""
          src="./../assets/dynamic/agent.png"
          alt="沐桦科技"
        />
      </div>

    </div>
    <div class="diff">
      <div class="muhua-title">传统代理与动态代理的区别</div>
      <div class="content">使用同一个IP频繁抓取同一个网站，很大可能会被该站屏蔽，此时一般会采取更换代理的策略。但是传统代理切换麻烦，操作繁琐，且会经常出现各种问题。以常见的抓取程序为例：</div>
      <div>
        <img
          src="./../assets/dynamic/diff.png"
          alt=""
        >
      </div>
    </div>
    <div class="ip muhua-wrap">
      <div class="muhua-title dynamic-title">数万IP地址</div>
      <div class="dynamic-little-title">基于大量雾计算节点获取真实家庭IP</div>
      <div class="content">
        <div class="left">
          <img
            class="border"
            src="./../assets/dynamic/little_ip.png"
            alt=""
          >
          <div class="text top-content">沐桦科技不断增加的雾计算设备网络让您可以一直使用海量真实IP资源</div>
          <!-- <div class="top-content top-line"></div> -->
          <div class="text">目前已有</div>
          <div class="count">135,301个IP资源
            <!-- <span class="unit">个</span> -->
          </div>
          <!-- <div class="unit-bottom">个IP资源</div> -->
        </div>
        <div class="right">
          <img
            class="border"
            src="./../assets/dynamic/ip.png"
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="city">
      <div
        data-v-7e947f75=""
        class="muhua-title title dynamic-title"
      >无论何地-任何地区、ASN或运营商</div>
      <div class="dynamic-little-title">资源覆盖全球上百个城市</div>
      <div>
        <img
          class="border"
          src="./../assets/dynamic/city.png"
          alt=""
        >
      </div>
    </div>
    <section class="type muhua-wrap">
      <div class="muhua-title title dynamic-title">任何IP类型-住宅、数据中心、移动</div>
      <div class="dynamic-little-title">一个通道获取海量IP</div>
      <div class="content">
        <div class="left">
          <img
            class="border"
            src="./../assets/dynamic/split.png"
            alt=""
          >
          <div class="text top-content">访问沐桦科技的P2P雾计算设备网络，不论是住宅网络，数据中心静态网络还是手机网络，全都只需要通过一个简单的界面接入使用</div>
          <div class="know-more"><a
              href="/ipDetail"
              class="href"
            >了解更多</a></div>
        </div>
        <div class="right">
          <img
            class="border"
            src="./../assets/dynamic/type.png"
            alt=""
          >
        </div>
      </div>
    </section>
    <section class="function-wrap">
      <div class="muhua-title function-title">主要功能</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dynamic/ipType.png"
              alt=""
            >
            <div class="card-title ">任何IP类型</div>
            <div class="detail">在数据中心静态、住宅动态和移动手机网络中切换</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dynamic/better.png"
              alt=""
            >
            <div class="card-title ">更好的IP网络</div>
            <div class="detail">沐桦科技提供数万IP，包含无限制，全天24小时可用</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dynamic/distribution.png"
              alt=""
            >
            <div class="card-title ">地理分布</div>
            <div class="detail">我们在任何您需要的地区、城市、ASN和运营商处都能提供IP</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dynamic/chat.png"
              alt=""
            >
            <div class="card-title ">并发会话</div>
            <div class="detail">通过发送无限制的并发请求最快手机数据</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dynamic/group.png"
              alt=""
            >
            <div class="card-title ">专属IP</div>
            <div class="detail">为特定目标网站使用专属IP</div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态代理网络服务</div>
      <div class="detail-wrap">
        <router-link to="/ipDetail" class="button compute">
        了解动态代理
        </router-link>
         <router-link to="/customerCase" class="button compute white-button">
        查看案例
        </router-link>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from 'vuex';
import Footer from '@/components/Footer.vue';
import Menu from '@/components/Menu.vue';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: {
    Footer,
    Header
  },
  computed: mapState({}),
  created () {},
  data () {
    return {
      activeIndex: '2-1-1'
    };
  }
};
</script>

<style scoped lang="stylus">
.function {
  background: rgba(248, 252, 255, 1);

  .content-wrap {
    display: flex;

    .card {
      width: 20%;
    }
  }
}

.type {
  background: rgba(255, 255, 255, 1);
  text-align: center;

  .content {
    display: flex;

    .left {
      width: 50%;
      text-align: left;

      img {
        width: 32px;
        height: 32px;
        margin: 88px 0 19px;
      }

      .text {
        font-size: 10px;
        font-weight: 400;
        color: rgba(63, 80, 124, 1);
        line-height: 19px;
        margin-bottom: 23px;
        max-width: 353px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 80, 124, 1);
        line-height: 27px;
      }

      .know-more {
        font-size: 9px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #00aeef;
        text-align: center;
        line-height: 38px;
        width: 133px;
        height: 38px;
        border-radius: 3px;
        border: 1px solid rgba(0, 174, 239, 1);

        a {
          color: rgba(0, 174, 239, 1);
          font-weight: bold;
        }
      }
    }

    .right {
      width: 50%;

      img {
        width: 442px;
        height: 355px;
        margin-bottom: 64px;
      }
    }
  }
}

.city {
  background: rgba(248, 252, 255, 1);
  text-align: center;

  img {
    max-width: 616px;
    max-height: 319px;
    margin-bottom: 28px;
  }
}

.dynamic-title {
  padding: 48px 0 13px;
  font-size: 29px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(63, 80, 124, 1);
  line-height: 32px;
}

.dynamic-little-title {
  font-size: 10px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(116, 133, 152, 1);
  margin-bottom: 32px;
  line-height: 27px;
}

.ip {
  .content {
    display: flex;
    text-align: left;

    .left {
      width: 37%;

      img {
        width: 32px;
        height: 32px;
        margin: 63px 0 14px;
      }

      .text {
        font-size: 14px;
        font-weight: 400;
        color: rgba(63, 80, 124, 1);
        line-height: 19px;
      }

      .top-line {
        margin-bottom: 23px;
      }

      .top-content {
        padding-bottom: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 80, 124, 1);
        line-height: 27px;
      }

      .count {
        margin: 25px 0;
        font-size: 26px;
        font-family: Arial-BoldMT;
        font-weight: normal;
        color: rgba(0, 174, 239, 1);
        line-height: 32px;
      }

      .unit {
        font-size: 8px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 174, 239, 1);
        line-height: 14px;
      }

      .unit-bottom {
        font-size: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 174, 239, 1);
        line-height: 27px;
      }
    }

    .right {
      width: 63%;
      text-align: center;

      img {
        width: 555px;
        height: 352px;
        margin-bottom: 45px;
      }
    }
  }
}

.diff {
  background: rgba(248, 252, 255, 1);
  text-align: center;

  .title {
    margin: 34px 0 9px;
    padding: 0px;
  }

  .content {
    margin: 0 auto;
    margin-bottom: 32px;
    width: 848px;
    height: 54px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(116, 133, 152, 1);
    line-height: 27px;
  }

  img {
    width: 640px;
    height: 349px;
    margin-bottom: 64px;
  }
}

.dynamic {
  display: flex;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;

  .left {
    width: 50%;

    .title {
      margin: 114px 0 43px;
      width: 418px;
      height: 32px;
      font-size: 29px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(63, 80, 124, 1);
      line-height: 32px;
    }

    .text {
      font-size: 10px;
      font-weight: 400;
      color: rgba(116, 133, 152, 1);
      line-height: 19px;
      padding-right: 20px;
      width: 464px;
      height: 109px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(116, 133, 152, 1);
      line-height: 27px;
    }

    .top {
      margin-bottom: 19px;
    }
  }

  .right {
    width: 50%;
    text-align: center;

    img {
      width: 366px;
      height: 448px;
      margin: 48px 0 64px;
    }
  }
}

.function-wrap {
  background: rgba(248, 252, 255, 1);

  .function-title {
    padding: 50px 0 48px;
  }

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;

    .card-wrap {
      width: 20%;

      .card {
        margin: 0 auto;
        text-align: center;
      }

      img {
        width: 64px;
        height: 48px;
        background: rgba(255, 255, 255, 1);
        margin-botton: 14px;
      }

      .card-title {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 13px 0;
      }

      .detail {
        margin-bottom: 59px;
        max-width: 150px;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(116, 133, 152, 1);
        line-height: 22px;
        text-align: center;
        margin: 0 auto 62px;
      }
    }
  }
}

.product-detail {
  background-image: url('../assets/background/white_point.png');
  background-size: cover;

  .detail-wrap {
    display: flex;
    justify-content: space-between;
    width: 327px;
    margin: 0 auto;
  }
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 400px;
  display: flex;

  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }

  .left-banner {
    width: 59%;

    .title {
      margin: 121px 0 19px 0;
      font-size: 38px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 64px;
    }

    .content {
      width: 383px;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 23px;
      margin-bottom: 27px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 32px;
    }

    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }

  .right-banner {
    width: 41%;

    img {
      height: 400px;
    }
  }
}

</style>
